import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Account } from '../model/account';
import { HttpUtil } from '../../../shared/util/http.util';
import { ApplicationConfig } from '../../../core/config/application.config';
import { RequestOptions } from '../../../shared/model/local/config/request-options';

@Injectable({ providedIn: 'root' })
export class AuthApiService {
  constructor(private readonly httpUtil: HttpUtil) {}

  public getCurrentLoggedUser(): Observable<Account> {
    const options = { silentMode: true } as RequestOptions;

    return this.httpUtil.get(
      `${ApplicationConfig.apiUrl}/${ApplicationConfig.apiVersion}/users/me`,
      undefined,
      options
    );
  }

  public changePassword(
    password: string,
    newPassword: string
  ): Observable<void> {
    return this.httpUtil.post(
      `${ApplicationConfig.apiUrl}/${ApplicationConfig.apiVersion}/users/change-password`,
      {
        password,
        newPassword,
      }
    );
  }
}
